import {parseDateIntoHermesString} from './../../../utils/date-utils';
import {prepareSrpOfferApiRequest} from './../utils/prepareSrpOfferApiRequest';
import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../store';
import {prepareSRPApiRequest} from '../utils/prepareSrpApiRequest';
import {
  fetchSrpDataAction,
  toggleIsLoadingAction,
  updateFilterAction,
  updateSrpOfferDataAction,
} from './actions';
import {ISrpData, IFilters, ISrpOfferDataItem, ISrpOfferData} from './types';
import {fixedFilters} from '../utils/filter-utils';
import {ArrayTogglerBehaviorTypes} from '../../../hooks/useArrayToggler';
import {updateQueryAction} from '@stencil/hotels-common-reducer/src/actions';
import {IUpdate_Query} from '@stencil/hotels-common-reducer/src/types';
import {fetchHelper} from '../../../utils/fetchHelper';
import {rnplPopularFilter} from '../utils/filter-utils';
export const removeFilterThunk = (
  filterTarget: keyof IFilters,
  // value: any, // ! add types later
  onFilterChangeCallback: Function,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {srp} = getState();
    const {srpConfig} = srp;
    const {filter = {}} = srpConfig;

    // ! this is not going to scale, need to pass variations of filter states
    // such as singleSelection, multiSelection, radio, etc
    if (filter[filterTarget] && filter[filterTarget].length) {
      if (
        Object.keys(fixedFilters)
          .map(fixedFiltersItemKey => fixedFilters[fixedFiltersItemKey].name)
          .indexOf(filterTarget) > -1 &&
        fixedFilters[filterTarget].type === ArrayTogglerBehaviorTypes.singleSelect
      ) {
        filter[filterTarget] = [];
      } else {
        const [value, ...rest] = filter[filterTarget];
        filter[filterTarget] = [...rest];
      }
      // dispatch(updateFilterAction(filter));
    }

    onFilterChangeCallback({newFilterData: filter, resetAllData: false, showOverlayLoader: true});
  };
};

export const fetchSrpDataThunk = (
  loadingMore: boolean = false,
  showFilterOverlay: boolean = false,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(
      toggleIsLoadingAction({isLoading: !loadingMore && true, displayOverlay: showFilterOverlay}),
    );

    const {srp, common} = getState();
    const {destination, checkin, checkout, roomString, country} = common;
    const {srpConfig, srpData, isSEO} = srp;
    const {metaPartner, filter = {}} = srpConfig;
    // const {isLoggedIn} = user;

    // if (!isLoggedIn && !!filter[rnplPopularFilter.symbol]) {
    //   filter[rnplPopularFilter.symbol] = 0; // rnpl filter is only valid for logged in users.
    // }

    const url = prepareSRPApiRequest({
      ...srpConfig,
      filter,
      destination,
      checkin,
      checkout,
      roomString,
      next: loadingMore ? srpData?.next : '',
    });

    fetchHelper({
      name: 'srp api',
      type: 'GET',
      url,
    })
      .then((response: ISrpData) => {
        if (!response.data) {
          dispatch(
            fetchSrpDataAction(
              {data: [], city_meta_info: response.city_meta_info, next: response.next},
              loadingMore,
            ),
          );
          dispatch(toggleIsLoadingAction({isLoading: false, displayOverlay: false}));

          return;
        }

        dispatch(fetchSrpDataAction(response, loadingMore));

        if (
          metaPartner &&
          (!destination.n || !destination._id) &&
          response &&
          response.city_meta_info
        ) {
          dispatch(
            updateQueryAction({
              destination: {_id: response.city_meta_info.vcid, n: response.city_meta_info.ct},
              country: response.city_meta_info?.coc || '',
            } as IUpdate_Query['actionData']),
          );
        } else if (response?.city_meta_info?.coc && (!isSEO || !country))
          dispatch(updateQueryAction({country: response?.city_meta_info?.coc}));
        dispatch(toggleIsLoadingAction({isLoading: false, displayOverlay: false}));
        // if (!loadingMore && response && response.data && response.data.length > 0) {
        //   dispatch(gaPageViewThunk('srp'));
        // }
      })
      .catch(err => {
        console.trace(err);
        // ! do something for error case
        dispatch(toggleIsLoadingAction({isLoading: false, displayOverlay: false}));
        // dispatch(fetchSrpDataAction({error: true}));
        // dispatch(updateHasDataAction(false));
      });
    // }
  };
};

export const fetchSrpOfferDataThunk = ({
  hotelId,
  pph,
}): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {common} = getState();
    const {destination, checkin, checkout, roomString} = common;
    const url = prepareSrpOfferApiRequest({
      roomString,
      checkin,
      checkout,
      destination,
      pph: pph,
      hotelId: hotelId,
    });

    fetchHelper({
      name: 'srp offer api',
      type: 'GET',
      url,
    })
      .then((response: {data: Array<ISrpOfferDataItem>}) => {
        const arg = {};
        if (response.data) {
          arg[hotelId] = {data: response.data};
          dispatch(updateSrpOfferDataAction(arg as ISrpOfferData));
        } else {
          arg[hotelId] = {error: 'Something went wrong. We are sending a fix'};
          dispatch(updateSrpOfferDataAction(arg as ISrpOfferData));
        }
      })
      .catch(err => {
        // ! do something for error case
        console.error(err);
      });
    // }
  };
};
